import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    Typography
} from "@mui/material";
import WarningTriangleIcon from "../images/WarningTriangleIcon.svg";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import { DialogTheme } from "../styles/DialogTheme";

const LargeReportDialog = ({ open, onClose }) => {
    const theme = useTheme();

    return (
        <ThemeProvider theme={DialogTheme(theme)}>
            <Dialog maxWidth="sm" open={open} onClose={onClose}>
                <DialogTitle
                    id="user-export-dialog-title"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "18px",
                        paddingBottom: "30px"
                    }}
                >
                    <img
                        src={WarningTriangleIcon}
                        alt="Warning"
                        style={{
                            width: "24px",
                            height: "24px"
                        }}
                    />
                    Large report
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        It may take a few minutes to generate this report – we
                        will download it automatically as soon as it's ready,
                        but in the meantime, feel free to use the system as
                        normal
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Grid
                        container
                        item
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end"
                        }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={onClose}
                        >
                            OK
                        </Button>
                    </Grid>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
};

export default LargeReportDialog;
